import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Heart } from 'lucide-react';

const AuthCallback = () => {
  const { processGoogleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          const user = await processGoogleSession(sessionId);
          // Clear the hash and navigate
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/feed', { replace: true, state: { user } });
        } catch (error) {
          console.error('Auth callback error:', error);
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [processGoogleSession, navigate]);

  return (
    <div className="min-h-screen bg-stone-100 flex items-center justify-center">
      <div className="text-center">
        <Heart className="h-12 w-12 text-emerald-800 mx-auto mb-4 animate-pulse" fill="currentColor" />
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-800 mx-auto mb-4"></div>
        <p className="text-stone-600">Autenticazione in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
